import formInputErrorFocus from '../functions/form-input-error-focus'

export default ({ Vue }) => {
    Vue.prototype.$formInputErrorFocus = formInputErrorFocus
}
